module.exports = __webpack_public_path__ + "static/media/s_v10_t6.53a0364e.mp3";